import React from 'react';

import Box from '../components/layout/Box';
import MainContentContainer from './MainContentContainer';
import ScrollContainer from './ScrollContainer';
import Footer from './Footer';

const CenteredPage = ({ children, className, style }) => {
  return (
    <ScrollContainer>
      <MainContentContainer>
        <Box
          className={`container-lg ${className}`}
          style={{ maxWidth: 940, ...style }}
        >
          {children}
        </Box>
      </MainContentContainer>

      <Footer />
    </ScrollContainer>
  );
};

CenteredPage.defaultProps = {
  className: '',
  style: {},
};

export default CenteredPage;
